import * as React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import { Client } from '../../models';
import { ClientEntryStore } from '../../stores/client-entry-store';

type Props = {
  title: string;
  client: Client;
  clientEntryStore: ClientEntryStore;
  // When this changes to a new non-empty value, the AI-generated draft replaces
  // the textarea contents (an editable draft — the practitioner reviews + Saves).
  aiDraft?: string;
};

type State = {
  text: string;
};

export class ClientNotes extends React.Component<Props, State> {
  state: State = {
    text: this.props.client.overallPractitionerNotes || '',
  };

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.client.id !== this.props.client.id) {
      this.setState({
        text: nextProps.client.overallPractitionerNotes || '',
      });
    }
    // A freshly generated AI draft replaces the textarea (not auto-saved).
    if (nextProps.aiDraft && nextProps.aiDraft !== this.props.aiDraft) {
      this.setState({ text: nextProps.aiDraft });
    }
  }

  handleInputChange = (event: any) => {
    const value = event.target.value;
    this.setState({
      text: value,
    });
  };

  saveOrUpdate = (event: any) => {
    const { client, clientEntryStore } = this.props;
    event.preventDefault();
    client.overallPractitionerNotes = this.state.text;

    // Ensure the current client in store is this one before saving,
    // or just set it as current client and save.
    clientEntryStore.setCurrentClient(client);
    clientEntryStore.saveOrUpdate();
  };

  render() {
    const { title } = this.props;
    return (
      <Form id="client-notes-form">
        <Form.Group controlId="clientForm.ControlTextarea1">
          <Form.Label>{title}</Form.Label>
          <Form.Control
            as="textarea"
            rows={13}
            name="notes-text"
            value={this.state.text}
            onChange={this.handleInputChange}
          />
        </Form.Group>
        <Form.Group as={Row}>
          <Col>
            <Button id="submitButton" type="submit" onClick={this.saveOrUpdate}>
              Save
            </Button>
          </Col>
        </Form.Group>
      </Form>
    );
  }
}
